export default __webpack_public_path__ + "static/Industrial_Forge-47ec92a3770521ad9805fa61f1ddbdd5.png";